import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../../core/services/role.service';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { StoreService } from '../../../../core/services/store.service';
import { StatusComponent } from '../../component/status/status.component';
import { OrderService } from '../../../../core/services/order.service';

@Component({
  selector: 'app-store',
  standalone: true,
  imports: [
     CommonModule,
            FormsModule,
            NgbModule,
            NgxPaginationModule,
            LoadingComponent,
            SampleSearchPipe,
            StatusComponent
  ],
  templateUrl: './store.component.html',
  styleUrl: './store.component.css'
})
export class StoreComponent {
 buttonsPermission :any|undefined;
 buttonsPermission2 :any|undefined;
 buttonsPermission3 :any|undefined;
  structures:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  dataFoods:any[] =[]
  dataOrders:any[] =[]
  windows:any[] =[]
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="Boutiques"
  permissionName=""
    search_text=""
role:any
  user:any
  loading2=false
pg={
    pageSize:10,
    p:0,
    total:0
  }
pg2={
    pageSize:10,
    p:0,
    total:0
  }
pg3={
    pageSize:10,
    p:0,
    total:0
  }


  constructor(
    private storeService:StoreService,
    private orderService:OrderService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
    this.getActions2()
    this.getActions3()
  }

  init(){
    this.getAll()
    this.getAll2()
    this.getAll3()
  
  }

 

  getAll(){
    this.loading2=true
    let query={
      type:"shop"
    }
    this.storeService.getAll(query).subscribe((res:any)=>{
      this.data=res.data 
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }
  getAll2(){
    this.loading2=true
    let query={
      type:"restaurant"
    }
    this.storeService.getAll(query).subscribe((res:any)=>{
      this.dataFoods=res.data 
      this.pg2.pageSize=10
      this.pg2.p=0
      this.pg2.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }
  getAll3(){
    this.loading2=true

    this.orderService.getAll().subscribe((res:any)=>{
      this.dataOrders=res.data 
      this.pg3.pageSize=10
      this.pg3.p=0
      this.pg3.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }


  store(value:any){
    this.loading=true
    value['guard_name']="api"
    this.storeService.store(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update(value:any){
    this.loading=true

    this.storeService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.storeService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }
  setState(value:any){
    if(!this.verifyIfElementChecked()) return ;
    this.loading=true
    this.storeService.setState(this.selected_data.id,value).subscribe((res:any)=>{
      this.toastrService.success(res.message)
      this.loading=false

      this.getAll()
  },
  (err:any)=>{
    this.loading=false

    console.log(err)
    AppErrorShow.showError("Gestion des rôles",err)
  })
  }
  setState2(value:any){
    if(!this.verifyIfElementChecked()) return ;
    this.loading=true
    this.storeService.setState(this.selected_data.id,value).subscribe((res:any)=>{
      this.toastrService.success(res.message)
      this.loading=false

      this.getAll2()
  },
  (err:any)=>{
    this.loading=false

    console.log(err)
    AppErrorShow.showError("Gestion des rôles",err)
  })
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }


  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:true,
    };
  }
  getActions2(){
    this.buttonsPermission2 = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:true,
    };
  }
  getActions3(){
    this.buttonsPermission3 = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
    };
  }

  getPage1(event:any){
    this.pg.p=event
  }
  getPage2(event:any){
    this.pg2.p=event
  }
  getPage3(event:any){
    this.pg3.p=event
  }
}
